import React, { FC } from "react";
import {
  Address,
  AddressUpdateData,
  useUpdateOrderAddressMutation,
} from "@apollo/ops";
import { AddressCard } from "@components/Address/AddressCard";

interface Props {
  shippingAddress: Address | null;
  organizationEmail: string | null;
  orderId: number;
  cardTitle?: string;
  disabled?: boolean;
}

export const ShippingAddressCard: FC<Props> = ({
  shippingAddress,
  organizationEmail,
  orderId,
  disabled = false,
  cardTitle = "Shipping Address",
}) => {
  const [mutate] = useUpdateOrderAddressMutation();
  const mutationFunc = async (address: AddressUpdateData) => {
    await mutate({ variables: { orderId, data: address } });
  };

  return (
    <div data-testid="ShippingAddressCard">
      <AddressCard
        existingAddress={shippingAddress}
        email={organizationEmail}
        mutationFunc={mutationFunc}
        cardTitle={cardTitle}
        disabled={disabled}
      />
    </div>
  );
};
